import React from 'react';
import "../styles/style.css";
const Button = () => {
    return (
        <>
            <div className="cta-button">
                <button>Get it on Chrome</button>
                <button>Get it on Firefox</button>
            </div>

        </>
    )
}

export default Button;
